import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWireErosionSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "12.444 7.943 3.478 13.119 3.479 13.119 3.479 15.707 12.5 20.915 21.522 15.707 21.522 13.119 12.444 7.943"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "15.266 7.113 15.682 7.788 16.443 8.05 17.308 7.788 17.621 7.113 17.771 7.113 18.188 5.819 14.699 5.819 15.115 7.113 15.266 7.113"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M21.769,13.05a.275.275,0,0,0-.014-.034l-.012-.026a.252.252,0,0,0-.022-.03l-9.15-5.24a.255.255,0,0,0-.255,0L3.351,12.9a.255.255,0,0,0-.128.228v2.582a.255.255,0,0,0,.128.221l9.021,5.209a.261.261,0,0,0,.128.034.267.267,0,0,0,.129-.034l9.02-5.209a.254.254,0,0,0,.129-.221V13.118Zm-9.525,5.425v2L3.735,15.559v-2ZM8.985,12.12l1.279.738a.255.255,0,0,0,.316-.049l.593-.342a2.25,2.25,0,0,0,1.906-.066.869.869,0,0,0,.5-.735.743.743,0,0,0-.183-.48l.339-.2,2.584,1.491a.255.255,0,0,0,.35-.094.255.255,0,0,0-.094-.349l-2.7-1.56a.281.281,0,0,0-.278,0l-.774.447a.256.256,0,0,0,0,.444c.154.088.245.2.245.3s-.087.2-.239.291a1.746,1.746,0,0,1-1.529,0,.255.255,0,0,0-.256,0l-.658.379-1.256-.724a.275.275,0,0,0-.277,0L6.731,12.829a.266.266,0,0,0-.132.226.272.272,0,0,0,.132.229l7,4.039-1.227.708L3.992,13.119l8.453-4.881,8.562,4.882-6.768,3.907-6.877-3.97Zm4.98,5.657v2l-1.208.7v-2Zm7.3-4.214v2l-6.787,3.918v-2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M14.338,6.075h.174l.359,1.117a.257.257,0,0,0,.244.178l.349.552a.253.253,0,0,0,.135.108l.76.262a.24.24,0,0,0,.084.015.267.267,0,0,0,.075-.011l.865-.263a.253.253,0,0,0,.158-.137l.244-.527a.255.255,0,0,0,.23-.177l.36-1.117h.174a.256.256,0,0,0,.256-.244l.1-2.192a.253.253,0,0,0-.067-.185.257.257,0,0,0-.178-.084.249.249,0,0,0-.268.244L18.3,5.563H14.582l-.093-1.949a.256.256,0,0,0-.267-.243.252.252,0,0,0-.178.083.256.256,0,0,0-.066.185l.1,2.192A.255.255,0,0,0,14.338,6.075Zm2.882,1.3-.1.206-.676.205-.6-.206-.128-.205ZM15.05,6.075h2.786l-.252.782H15.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M16.212,19.068v2.3a.232.232,0,1,0,.463,0V18.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M16.518,8.3a.267.267,0,0,1-.075.011.24.24,0,0,1-.084-.015l-.147-.051v4.018a.232.232,0,1,0,.463,0V8.248Z"
		})
	]
});
export default SvgWireErosionSm;
